import React from "react";
import { Pencil, Trash2, Loader2, Calendar, Users } from "lucide-react";
import { cx, Pill, formatMoneyXOF, clampDate } from "./helpers.js";

export default function ProjectCard({ project, projectStatusConfig, deletingProjectId, onEdit, onDelete, onViewPrestations }) {
  const s = projectStatusConfig[project.status] || projectStatusConfig.DRAFT;
  const amount = Number(project.total_amount_calc || 0);
  const nbPrestations = Number(project.prestations_count || 0);

  return (
    <div className="group rounded-3xl border border-slate-200 bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="truncate text-base font-extrabold text-slate-900">{project.title}</h3>
            <Pill tone={s.tone}>{s.label}</Pill>
          </div>
          <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-500">
            <span className="rounded-full bg-slate-50 px-2 py-1 ring-1 ring-slate-200">{project.code || "—"}</span>
            {project.customer_name && (
              <span className="inline-flex items-center gap-1">
                <Users className="h-3.5 w-3.5" />
                {project.customer_name}
              </span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-1">
          <button
            onClick={() => onEdit(project)}
            className="rounded-2xl border border-slate-200 bg-white p-2 opacity-90 hover:bg-slate-50"
            title="Modifier"
          >
            <Pencil className="h-4 w-4 text-slate-700" />
          </button>
          <button
            onClick={() => onDelete(project)}
            disabled={deletingProjectId === project.id}
            className="rounded-2xl border border-rose-100 bg-white p-2 opacity-90 hover:bg-rose-50 disabled:opacity-40"
            title="Supprimer"
          >
            {deletingProjectId === project.id
              ? <Loader2 className="h-4 w-4 animate-spin text-rose-500" />
              : <Trash2 className="h-4 w-4 text-rose-500" />
            }
          </button>
        </div>
      </div>

      {project.description ? (
        <p className="mt-3 line-clamp-2 text-sm text-slate-600">{project.description}</p>
      ) : (
        <p className="mt-3 text-sm text-slate-400 italic">Aucune description.</p>
      )}

      <div className="mt-4">
        <div className="flex items-center justify-between text-xs text-slate-500">
          <span>Avancement</span>
          <span className="font-medium text-slate-700">{s.pct}%</span>
        </div>
        <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-slate-100">
          <div className="h-full rounded-full bg-slate-900 transition-all" style={{ width: `${s.pct}%` }} />
        </div>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-3">
        <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3">
          <div className="text-xs text-slate-500">Prestations</div>
          <div className="mt-1 text-sm font-bold text-slate-900">{nbPrestations}</div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3">
          <div className="text-xs text-slate-500">Montant</div>
          <div className="mt-1 text-sm font-bold text-slate-900">{formatMoneyXOF(amount)}</div>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between text-xs text-slate-500">
        <span className="inline-flex items-center gap-1">
          <Calendar className="h-3.5 w-3.5" />
          Début: {project.start_date ? clampDate(project.start_date) : "—"}
        </span>
        <span>Fin: {project.end_date ? clampDate(project.end_date) : "—"}</span>
      </div>

      <button
        onClick={onViewPrestations}
        className="mt-5 w-full rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-900 hover:bg-slate-50"
      >
        Voir les prestations
      </button>
    </div>
  );
}
